import React from 'react';
import Spinner from '@atlassian/jira-common-components-spinner/src/view.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { Props } from './types.tsx';

const LazyLicenseViolationErrorPage = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "async-arj-license-violation-page", jiraPriority: 'ondemand' */ './index'
		),
);

export const AsyncLicenseViolationErrorPage = (props: Props) => (
	<Placeholder name="arj-license-violation-page" fallback={<Spinner />}>
		<LazyLicenseViolationErrorPage {...props} />
	</Placeholder>
);
